import React from "react";
import SeekerSearchStatistics from "./SeekerSearchStatistics";
import SeekerSubmittedStatistics from "./SeekerSubmittedStatistics";
import Stack from "@mui/material/Stack";
import SeekerAwardsStatistics from "./SeekerAwardsStatistics";
import SeekerGraphs from "./seekerGraphs";
const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};

export default function SeekerOverview() {
  return (
    <div style={containerStyle}>
      <Stack spacing={4} style={{ paddingBottom: "30px" }}>
        <SeekerGraphs/>
        <SeekerSearchStatistics />
        <SeekerSubmittedStatistics />
        <SeekerAwardsStatistics />
      </Stack>
    </div>
  );
}
